import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { includes, reject } from 'lodash';
import MuiChip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';

import TextField from 'WeployDesignLanguage/inputs/TextField';

import dagstorp from 'LegacyWeployDesignLanguage/dagstorp';

const DEFAULT_TAG_VALUE = '';
const ENTER_KEY_CODE = 13;

const StyledChip = withStyles({
  root: {
    backgroundColor: dagstorp.colors.text.primary,
    marginRight: dagstorp.spacing[1],
    marginBottom: dagstorp.spacing[1],
  },
  label: {
    color: dagstorp.colors.text.primaryOnDark,
    ...dagstorp.typography.subtitle1,
  },
  deleteIcon: {
    color: dagstorp.colors.text.primaryOnDark,
  },
})(MuiChip);

const SkillsPane = styled.div`
  padding: ${dagstorp.spacing[1]};
  min-height: ${dagstorp.spacing[5]};
  &:last-child {
    margin-right: ${dagstorp.spacing[0]};
  }
`;

const MultiSelect = ({
  tags,
  onTagsChange,
  ...rest
}) => {
  const [currentInputValue, setCurrentInputValue] = useState(DEFAULT_TAG_VALUE);

  const handleRemove = (removedTag) => {
    const newTags = reject([...tags], tag => (tag === removedTag));

    onTagsChange(newTags);
  };

  const handleTagSubmit = (tag) => {
    setCurrentInputValue(DEFAULT_TAG_VALUE);
    if (includes(tags, tag)) {
      return;
    }

    const newTags = [...tags, tag];
    onTagsChange(newTags);
  };

  const handleKeyPress = (event) => {
    if (event.charCode === ENTER_KEY_CODE && currentInputValue) {
      event.preventDefault();
      handleTagSubmit(currentInputValue);
    }
  };

  return (
    <>
      <TextField
        onChange={event => setCurrentInputValue(event.target.value)}
        onKeyPress={handleKeyPress}
        value={currentInputValue}
        InputLabelProps={{
          shrink: true,
        }}
        {...rest}
      />
      <SkillsPane>
        {
          tags.map(tag => (
            <StyledChip
              key={tag}
              label={tag}
              onDelete={() => handleRemove(tag)}
            />
          ))
        }
      </SkillsPane>
    </>
  );
};

MultiSelect.propTypes = {
  onTagsChange: PropTypes.func,
  tags: PropTypes.arrayOf(PropTypes.string),
};

MultiSelect.defaultProps = {
  onTagsChange: () => {},
  tags: [],
};

export default MultiSelect;
